import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl';

const ErrorBookingsCapacity = ({ wrapperClassName }) => (
  <div
    className={`
      flex md:justify-end
      ${wrapperClassName}
    `}
  >
    <div className="md:w-2/5 text-red-dark text-sm bg-grey-lighter p-4 border-red-dark border-r">
      <div className="font-bold">
        <FormattedMessage id="booking.amountForm.atCapacity.header" defaultMessage="At booking amount maximum" /> 
      </div>
      <div className="">
        <FormattedMessage id="booking.amountForm.atCapacity.desc" defaultMessage="Your membership type is allowed 2 active bookings " /> 
      </div>                      
    </div>
  </div>
)

ErrorBookingsCapacity.propTypes = {
  wrapperClassName: PropTypes.string
}

ErrorBookingsCapacity.defaultProps = {
  wrapperClassName: ''
}
  
export default ErrorBookingsCapacity